import { ApiResponse, FormStore, GlobalStore } from '@roc/feature-app-core';
import { flow, makeObservable } from 'mobx';
import { DrawService } from '../services/drawService';
import { Draw } from '../types/draws';

const initialForm = {
  fields: {
    inspectionCompany: {
      value: '',
      error: null,
      rule: '',
    },
    invoiceNumber: {
      value: '',
      error: null,
      rule: '',
    },
    invoiceDate: {
      value: null,
      error: null,
      rule: '',
    },
  },
  meta: {
    key: null,
    editMode: false,
    isValid: false,
    showErrors: null,
    error: null,
  },
}


export class InspectionInvoiceDetailsFormStore extends FormStore {

  private globalStore: GlobalStore;
  private drawService: DrawService;

  constructor(globalStore) {
    super(initialForm, globalStore);
    this.drawService = new DrawService();
    this.globalStore = globalStore;

    makeObservable(this, {
      loadInspectionInvoiceDetails: flow,
      updateInspectionInvoice: flow,
    });
    this.reset();
  }

  reset() {
    super.reset();
  }

  *loadInspectionInvoiceDetails(drawId: number) {
    try {
      this.reset();
      const response: ApiResponse = yield this.drawService.getDrawDTOById(`${drawId}`);
      const draw = response?.data?.data?.draw;
      if (!draw) {
        throw new Error(`Couldn't find draw with id ${drawId}`)
      }
      const drawInfoJson = draw?.drawRequestJsonContent || "{}";
      const drawInfo = JSON.parse(drawInfoJson);
      this.loadForm({
        inspectionCompany: draw.inspectionCompany,
        invoiceNumber: drawInfo.invoice,
        invoiceDate: drawInfo.invoiceDate
      });
    } catch (err) {
      console.error(err);
      this.globalStore.notificationStore.showErrorNotification({
        message: 'There was an error loading the Inspection Invoice Details.',
      });
    }

  }

  *updateInspectionInvoice(drawId: number) {
    try {
      const formData: any = this.getFlattenedValues();
      const request = { invoiceNumber: formData.invoiceNumber, invoiceDate: formData.invoiceDate, drawId };
      yield this.drawService.updateInspectionInvoice(request);
      this.globalStore.notificationStore.showSuccessNotification({
        message: "Inspection Invoice Details have been submitted successfully.",
      });
      return true;
    } catch (err) {
      console.error(err);
      this.globalStore.notificationStore.showErrorNotification({
        message: 'There was an error updating the Inspection Invoice Details.',
      });
      return false;
    }
  }
}